import NiceModal from "@ebay/nice-modal-react";

const textProps = {
  brand: {
    text: "Agentwire",
    image: require("assets/img/aw-logo.jpg").default,
    link: {
      href: "/admin",
    },
  },
  activeColor: "lightBlue",
  items: [
    {
      divider: true,
    },
    {
      icon: "fas fa-home",
      text: "Home",
      active: false,
      link: {
        href: "/admin",
      },
    },
    {
      divider: true,
    },
    {
      title: "Admin",
      admin: true,
    },
    {
      icon: "fas fa-users",
      text: "Clients",
      active: false,
      link: {
        href: "/admin/clients",
      },
      admin: true,
    },
    {
      icon: "fas fa-users",
      text: "Users",
      active: false,
      link: {
        href: "/admin/users",
      },
      admin: true,
    },
    {
      icon: "fas fa-comments",
      text: "Meet",
      active: false,
      link: {
        href: "/admin/meet/main",
      },
      admin: true,
    },
    {
      divider: true,
      admin: true,
    },
    {
      icon: "fas fa-comments",
      text: "Agents",
      active: false,
      link: {
        href: "/admin/agents",
      },
    },
    {
      icon: "fas fa-video",
      text: "Media",
      active: false,
      link: {
        /*href:"/admin/media",*/
        click: () => {
          alert("Not implemented yet. Find in agents.");
        },
      },
      client: true,
    },
    {
      icon: "fas fa-file",
      text: "Generated Content",
      active: false,
      link: {
        /*href:"/admin/supporting-content", */
        click: () => {
          alert("Not implemented yet. Find in agents.");
        },
      },
      client: true,
    },
    {
      icon: "fas fa-comment",
      text: "Chats",
      active: false,
      link: {
        /*href:"/admin/chats",*/
        click: () => {
          alert("Not implemented yet. Find in agents.");
        },
      },
      client: true,
    },
    {
      icon: "fas fa-users",
      text: "Users",
      active: false,
      link: {
        href: "/admin/users",
      },
    },
    {
      divider: true,
    },
    {
      icon: "fas fa-comments",
      text: "Workflows",
      active: false,
      link: {
        href: "/admin/workflows",
      },
      admin: true,
    },
    {
      icon: "fas fa-comments",
      text: "Nodes",
      active: false,
      link: {
        href: "/admin/nodes",
      },
      admin: true,
    },
    {
      icon: "fas fa-comments",
      text: "Functions",
      active: false,
      link: {
        href: "/admin/functions",
      },
      admin: true,
    },
    {
      divider: true,
      admin: true,
    },
    {
      title: "Settings",
      admin: true,
    },
    {
      icon: "fas fa-cog",
      text: "Client View",
      link: {
        href: "/",
      },
      admin: true,
    },
    {
      divider: true,
      admin: true,
    },
    {
      icon: "fa fa-sign-out-alt",
      text: "Logout",
      link: {
        href: "/admin/login?logout=true",
      },
    },
  ],
};
export default textProps;
